import { ConfirmModal } from './ConfirmModal'
import { useModalControl } from './useModalControl'

export const useConfirmModal = () => {
  return useModalControl(ConfirmModal)
}
